
export const DUMMY_BRIDGE_ITEM = "DUMMY_BRIDGE_ITEM"

export const BRIDGE_NOT_EDITED_ALERT = "Bridge Not Edited Alert"

export const DISABLED_BRIDGE_ITEMS = ["Contribution Margin", "Operating Margin", DUMMY_BRIDGE_ITEM]